import { defineMessages } from 'react-intl';

export const feedbackPopoverMessages = defineMessages({
  positiveLabel: {
    defaultMessage: 'Thumbs up - positive feedback',
    id: 'tLnKd4BTL3',
    description: 'Accessible label for the positive feedback button',
  },
  negativeLabel: {
    defaultMessage: 'Thumbs down - negative feedback',
    id: 'N8/Qkl+SfZ',
    description: 'Accessible label for the negative feedback button',
  },
  positiveTooltip: {
    defaultMessage: 'Good response',
    id: 'IWdvGu7/1g',
    description: 'Tooltip shown when hovering the positive feedback button',
  },
  negativeTooltip: {
    defaultMessage: 'Bad response',
    id: '3u4IJI5Ihg',
    description: 'Tooltip shown when hovering the negative feedback button',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'djwGFrg/UA',
    description: 'Secondary action to dismiss the feedback popover without submitting',
  },
  submit: {
    defaultMessage: 'Submit',
    id: 'Denx7Jn28C',
    description: 'Primary action to send feedback from the popover',
  },
  submitting: {
    defaultMessage: 'Submitting...',
    id: 'vGCJ0Yw9uL',
    description: 'Submit button label while feedback is being sent',
  },
});
